export { default } from "./table-footer";
